import type { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/utils/cn';

type RangeProps = {
  ariaLabel: string;
} & ComponentPropsWithoutRef<'input'>;

export const Range = ({ ariaLabel, className, ...props }: RangeProps) => {
  return (
    <input
      type="range"
      min="0"
      max="100"
      step={5}
      {...props}
      aria-label={ariaLabel}
      className={cn(
        'w-full h-10 rounded-lg appearance-none cursor-grab accent-purple-600',
        className,
      )}
    />
  );
};
